
import { Component, Prop, Vue } from "vue-property-decorator";
import { Getter, Action, Mutation } from "vuex-class";
import Loader from "@/components/App/Loader.vue";
import appConstants from "@/appConstants";

@Component({
  components: {
    Loader
  }
})
export default class ContactForm extends Vue {
  @Prop() private title!: string;
  @Prop() private from!: string; 
  @Prop() private firstname!: string;
  @Prop() private lastname!: string;
  @Prop() private email!: string;
  @Prop() private isPrimaryContact!: boolean;
  @Prop() private releaseContact!: boolean;

  get name() {
    if (!this.email) {
      return "Not Assigned";
    } else if (this.firstname == "" || this.lastname == "")
    {
       return "";
    }
    else
    {
      return this.firstname + " " + this.lastname
    }
  }

  get btntext() {
    if (!this.email) {
      return "Assign " + this.title;
    } else return "Edit " + this.title;
  }

  get route() {
    return "/membercontact/" + this.title.split(" ")[0].toLowerCase();
  }

}
